import * as React from "react";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { decorateEditorialHtml } from "components/flexComponents/Editorial/ContentUtilities";

/**
 * Editorial item for a items with contentPurpose: Confidence message (and Highlights apparently)
 */
export const ConfidenceEditorialItem = ({
  id,
  text,
  uitkIconName,
  iconSize,
  boxType,
}: {
  id: string;
  text?: string;
  uitkIconName?: string;
  iconSize?: string;
  boxType?: string;
}) => {
  const confidenceUitkIconName = uitkIconName || "done";
  const useUitkCard = boxType === "blossom-white";

  const mainContent = (
    <UitkLayoutFlex
      alignItems="center"
      data-testid="confidenceMsg"
      data-fm-content={id}
      className="confidenceMessageItem all-t-margin-two"
    >
      <UitkIcon
        name={confidenceUitkIconName}
        size={iconSize === "large" ? UitkIconSize.LARGE : UitkIconSize.MEDIUM}
        data-testid="confidenceIcon"
        className={confidenceUitkIconName}
      />
      <span className="uitk-type-300 all-l-margin-two" dangerouslySetInnerHTML={decorateEditorialHtml(text)} />
    </UitkLayoutFlex>
  );

  return useUitkCard ? (
    <UitkCard>
      <UitkCardContentSection>{mainContent}</UitkCardContentSection>
    </UitkCard>
  ) : (
    mainContent
  );
};
